import { useCallback, useEffect, useState } from 'react';
import { Alert } from 'react-native';
import { isLoggedIn } from '../api/auth';
import { getLibraryState, toggleFavorite } from '../api/library';

export function useFavoriteState(bookId?: number, onRequireLogin?: () => void) {
  const [favorite, setFavorite] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let mounted = true;

    if (!bookId || !isLoggedIn()) {
      setFavorite(false);
      return () => {
        mounted = false;
      };
    }

    getLibraryState(bookId)
      .then((state) => {
        if (mounted) setFavorite(state.is_favorite);
      })
      .catch(() => {
        if (mounted) setFavorite(false);
      });

    return () => {
      mounted = false;
    };
  }, [bookId]);

  const toggle = useCallback(async () => {
    if (!bookId) return;

    if (!isLoggedIn()) {
      onRequireLogin?.();
      return;
    }

    const nextFavorite = !favorite;
    setFavorite(nextFavorite);
    setLoading(true);

    try {
      const state = await toggleFavorite(bookId, nextFavorite);
      setFavorite(state.is_favorite);
    } catch {
      setFavorite(favorite);
      Alert.alert('Không thể cập nhật yêu thích', 'Vui lòng thử lại sau.');
    } finally {
      setLoading(false);
    }
  }, [bookId, favorite, onRequireLogin]);

  return { favorite, loading, toggle };
}
